export default {
      id: "milk-usage",
      viewBox: "0 0 14 22",
      url: __webpack_public_path__ + "img/icons.svg#milk",
      toString: function () {
        return this.url;
      }
    }